import React from "react"

interface BlogPageProps {
  blok: any
}

export default function BlogPage({ blok }: BlogPageProps) {
  return (
    <main>
      <h1>{blok?.title || "Blog Page"}</h1>
    </main>
  )
}
